import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, requiredRole }) => {
    const token = localStorage.getItem("token");
    const userStr = localStorage.getItem("user");
    const user = userStr ? JSON.parse(userStr) : null;

    if (!token) {
        return <Navigate to="/login" />;
    }

    // If requiredRole is specified, check if user's role matches
    if (requiredRole && user?.role !== requiredRole) {
        // Optionally redirect to dashboard or show unauthorized page
        return <Navigate to="/dashboard" />;
    }

    return children;
};

export default PrivateRoute;
